import {Grid} from '@mui/material';
import {useState} from 'react';
import {Product} from '../../../__generated__/resolvers-types';
import MonthlyAnnualSelector from '../../../components/monthlyAnnualSelector/MonthlyAnnualSelector';
import SubscriptionOptionCard from './SubscriptionOptionCard';

export interface SubscriptionOptionProps {
  products: Product[];
  handleSubscribe: (priceId: string) => void;
}

export default function SubscriptionOption({products, handleSubscribe}: SubscriptionOptionProps) {
  const [isMonthly, setIsMonthly] = useState(true);

  return (
    <>
      <MonthlyAnnualSelector isMonthly={isMonthly} setIsMonthly={setIsMonthly} />
      <Grid container spacing={3} justifyContent="center">
        {products.map((product) => (
          <SubscriptionOptionCard
            key={product.id}
            product={product}
            isMonthly={isMonthly}
            handleSubscribe={handleSubscribe}
          />
        ))}
      </Grid>
    </>
  );
}
